// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".MenuHorizontal{background:repeating-linear-gradient(90deg,#f7f0fc,#f7f0fc 3px,#f5ecfb 0,#f5ecfb 6px)}.MenuHorizontal .row>div{padding:0 .25rem}.MenuHorizontal__item>a{border:0;box-shadow:0 .25rem .25rem rgba(26,26,26,.09);transition:box-shadow .25s ease-in-out}.MenuHorizontal__item>a:focus,.MenuHorizontal__item>a:hover{box-shadow:0 .5rem 1.25rem -.5rem rgba(26,26,26,.32);color:#c6226f}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
